import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchExpediaCategories } from '../../../../../api/expediaApi/expediaCategories'
import {
    deleteExpediaRate,
    fetchExpediaRates,
    importExpediaRates,
    postExpediaRate
} from '../../../../../api/expediaApi/expediaRates'
import { selectCurrentOrganization } from '../../../../../selectors/expediaSelectors/expediaCurrentOrganization'
import { selectEasymsRatesKV } from '../../../../../selectors/expediaSelectors/expediaEasymsSelector'
import { selectRates, selectRatesFetching } from '../../../../../selectors/expediaSelectors/expediaRates'
import { selectCategories } from '../../../../../selectors/expediaSelectors/expediaCategories'
import RatesTable from './RatesTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class RatesTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        rates: PropTypes.array.isRequired,
        easymsRatesKV: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchExpediaRates: PropTypes.func.isRequired,
        fetchExpediaCategories: PropTypes.func.isRequired,
        postExpediaRate: PropTypes.func.isRequired,
        deleteExpediaRate: PropTypes.func.isRequired,
        importExpediaRates: PropTypes.func.isRequired
    }

    state = {
        ourId: '',
        remoteId: '',
        remoteName: '',
        remoteRoomId: ''
    }

    componentDidMount() {
        const params = { organizationId: this.props.currentOrganization }
        this.props.fetchExpediaRates(params)
        this.props.fetchExpediaCategories(params)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentOrganization !== this.props.currentOrganization) {
            const params = { organizationId: this.props.currentOrganization }
            this.props.fetchExpediaRates(params)
            this.props.fetchExpediaCategories(params)
            this.setState({ ourId: '' })
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleClick = () => {
        const { ourId, remoteId, remoteName, remoteRoomId } = this.state
        this.props.postExpediaRate({
            organizationId: this.props.currentOrganization,
            ourId,
            remoteId: remoteId.trim(),
            remoteName: remoteName.trim(),
            remoteRoomId: remoteRoomId.trim(),
            active: true
        })
        this.setState({
            ourId: '',
            remoteId: '',
            remoteName: '',
            remoteRoomId: ''
        })
    }

    handleDelete = remoteId => {
        this.props.deleteExpediaRate(remoteId)
    }

    handleUpdate = rate => {
        this.props.postExpediaRate({
            organizationId: this.props.currentOrganization,
            ourId: rate.ourId,
            remoteId: rate.remoteId,
            remoteName: rate.remoteName,
            remoteRoomId: rate.remoteRoomId,
            active: rate.active
        })
    }

    handleLoadImport = () => {
        this.props.importExpediaRates()
    }

    render() {
        const { classes, fetching, rates, currentOrganization, easymsRatesKV, categories } = this.props
        const { ourId, remoteId, remoteRoomId, remoteName } = this.state

        const valid = ourId && remoteId.trim() && remoteName.trim() && remoteRoomId.trim()

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TextField
                        select
                        label="Тариф EasyMS"
                        className={classes.formControl}
                        value={ourId}
                        onChange={this.handleSelect('ourId')}
                    >
                        {easymsRatesKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="rates-remote-id">ID тарифа Expedia.com</InputLabel>
                        <Input id="rates-remote-id" name="remoteId" value={remoteId} onChange={this.handleChange} />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="rates-remote-room-id">ID категории Expedia.com</InputLabel>
                        <Input
                            id="rates-remote-room-id"
                            name="remoteRoomId"
                            value={remoteRoomId}
                            onChange={this.handleChange}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="rates-remote-name">Имя тарифа Expedia.com</InputLabel>
                        <Input
                            id="rates-remote-name"
                            name="remoteName"
                            value={remoteName}
                            onChange={this.handleChange}
                        />
                    </FormControl>

                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Сохранить
                    </Button>
                </Paper>

                <Button
                    disabled={!currentOrganization}
                    variant="raised"
                    color="primary"
                    className={classes.button}
                    onClick={this.handleLoadImport}
                >
                    Импортировать тарифы с Expedia.com
                </Button>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <RatesTable rates={rates} categories={categories} onDelete={this.handleDelete} onUpdate={this.handleUpdate} />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        rates: selectRates(state),
        categories: selectCategories(state),
        fetching: selectRatesFetching(state),
        currentOrganization: selectCurrentOrganization(state),
        easymsRatesKV: selectEasymsRatesKV(state)
    }),
    {  fetchExpediaCategories, fetchExpediaRates, postExpediaRate, deleteExpediaRate, importExpediaRates }
)(withStyles(styles)(RatesTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/RatesTab/RatesTab.js